// created by wang.ao 2019/08/01
import * as demo from './demo';
import * as common from './common';
import * as website from './website';
import { Api } from '../types/Api';
const apis: { [key: string]: Api } = Object.assign({}, demo, common,website);

export { apis };
